/**
 * Shared Tailwind class constants used across the DataGrid rendering
 * modules. Kept in one place so tweaking a density or alignment rule
 * doesn't require hunting through multiple JSX files.
 *
 * Currently `DENSITY_CELL` and `DENSITY_HEADER` map to the same values,
 * but they stay separate on purpose — header rows often need a different
 * padding / font size than body cells, and hard-coding them once here
 * makes that future divergence a one-line change.
 */

export const ALIGN_CLASS = {
  left: 'text-left',
  center: 'text-center',
  right: 'text-right',
} as const;

export const DENSITY_CELL = {
  comfortable: 'px-4 py-3',
  compact: 'px-3 py-2',
} as const;

export const DENSITY_HEADER = {
  comfortable: 'px-4 py-3',
  compact: 'px-3 py-2',
} as const;

export type Density = 'comfortable' | 'compact';
